import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Automatically scrolls the window to the top when changing pages
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
